<h3 class="ui header light user-step-title">Course Outcome Details</h3>

<div *ngIf="loading.isLoading;else loaded">
  <app-loading [loadingText]="loading.text"></app-loading>
</div>

<ng-template #loaded>

  <app-load-error *ngIf="loadError; else noErrors" [loadError]="loadError">
  </app-load-error>


  <ng-template #noErrors>

    <ng-container
      *ngIf="(this.assessmentFormat.isEnabled && this.assessmentFormat.requiredByCourseOutcome) || 
      (this.tlaFormat.isEnabled && this.tlaFormat.requiredByCourseOutcome) || 
      questions.length > 0; else noQuestions">

      <div class="user-step-instruction">
        Please answer the additional questions about each course outcome.
      </div>


      <!-- 
        <app-action-errors *ngIf="actionErrors.length > 0" [title]="actionErrorTitle" [actionErrors]="actionErrors">
        </app-action-errors> -->

      <div *ngIf="courseOutcomes.length == 0; else courseOutcomesExist" class="ui message">
        You have not added any course outcomes.
      </div>


      <ng-template #courseOutcomesExist>

        <div *ngFor="let courseOutcome of courseOutcomes; let i = index;" class="course-outcome-segment ">
          <div class="ui top attached segment course-outcome-title">
            <div>{{i+1}}. {{courseOutcome.description}}</div>
          </div>

          <div class="outcome-assessment ui segment attached" *ngIf="assessmentFormat.requiredByCourseOutcome">

            <div class="instruction">Select the assessment methods used to assess this course outcome (if any).</div>


            <div class="ui form">
              <div class="grouped fields">
                <div class="field" *ngFor="let selectedAssessmentMethod of assessmentMethodsForCourse">
                  <div class="ui checkbox">
                    <input type="checkbox"
                      [(ngModel)]="selectedAssessmentIdsArray[courseOutcome.id][selectedAssessmentMethod.id]"
                      [disabled]="saving" (change)="valueChanged()">
                    <label>{{selectedAssessmentMethod.methodName}}
                      <span *ngIf="selectedAssessmentMethod.description">:
                        {{selectedAssessmentMethod.description}}</span>
                    </label>
                  </div>
                </div>
              </div>

            </div>



          </div>

          <div class="outcome-tla ui segment attached" *ngIf="tlaFormat.requiredByCourseOutcome">

            <div class="instruction">Select the teaching and learning activities used for this course outcome (if
              any).</div>

            <div *ngIf="tlaOptionsForCourse.length == 0">
              <div class="ui message warning">
                You have not added any teaching and learning activities for the course.
              </div>
            </div>

            <div class="ui form">
              <div class="grouped fields">
                <div class="field" *ngFor="let selectedTlaOption of tlaOptionsForCourse">
                  <div class="ui checkbox">
                    <input type="checkbox"
                      [(ngModel)]="selectedTlaIdsArray[courseOutcome.id][selectedTlaOption.selectionId]"
                      [disabled]="saving" (change)="valueChanged()">
                    <label>{{selectedTlaOption.description}}
                      <span *ngIf="selectedTlaOption.additionalText">: {{selectedTlaOption.additionalText}}</span>
                    </label>
                  </div>
                </div>
              </div>

            </div>

          </div>


          <div class="outcome-questions ui segment attached" *ngIf="courseOutcome.questions.length > 0">


            <div class="instruction">Please answer the following questions about this course outcome.</div>

            <div class="ui form questions-list"
              *ngFor="let question of courseOutcome.questions; let questionIndex = index;">


              <div class="question-text">{{questionIndex + 1}}. {{question.question}}</div>


              <div *ngIf="question.format == 'text' && question.textAnswer" class="outcome-question">



                <div class="field">

                  <textarea rows="2" [(ngModel)]="answersArray[courseOutcome.id][question.id].textAnswer"
                    (keyup)="valueChanged()" [disabled]="saving"></textarea>

                </div>
              </div>

              <div *ngIf="question.format == 'checkbox' || question.format == 'radio'" class="outcome-question">


                <div class="field">



                  <div class="grouped fields" *ngIf="question.format == 'checkbox' && question.options">

                    <div class="field" *ngFor="let option of question.options">
                      <div class="ui checkbox">
                        <input type="checkbox"
                          [(ngModel)]="answersArray[courseOutcome.id][question.id].options[option.id].isSelected"
                          [disabled]="saving" (change)="valueChanged()">
                        <label>{{option.description}} <span *ngIf="option.otherTextRequired">(Please
                            describe)</span></label>
                      </div>

                      <div class="ui input other-text-input"
                        *ngIf="option.otherTextRequired && answersArray[courseOutcome.id][question.id].options[option.id].isSelected">
                        <input placeholder="Please describe" type="text"
                          [(ngModel)]="answersArray[courseOutcome.id][question.id].options[option.id].otherText"
                          (keyup)="valueChanged()" [disabled]="saving" />
                      </div>

                    </div>
                  </div>

                  <div class="grouped fields" *ngIf="question.format == 'radio'">
                    <div class="field" *ngFor="let option of question.options">
                      <div class="ui radio checkbox">
                        <input type="radio"
                          [checked]="answersArray[courseOutcome.id][question.id].options[option.id].isSelected"
                          [attr.name]="'answer-option-radio-' + question.id + '-' + courseOutcome.id"
                          (change)="radioSelectionChanged(courseOutcome.id, question.id, option.id)"
                          [disabled]="saving">
                        <label>{{option.description}}</label>
                      </div>

                      <div class="ui input other-text-input"
                        *ngIf="option.otherTextRequired && answersArray[courseOutcome.id][question.id].options[option.id].isSelected">
                        <input placeholder="Please describe" type="text"
                          [(ngModel)]="answersArray[courseOutcome.id][question.id].options[option.id].otherText"
                          (keyup)="valueChanged()" [disabled]="saving" />
                      </div>

                    </div>
                  </div>

                </div>

              </div>


            </div>
          </div>



          <div class="ui bottom attached segment"
            *ngIf="!assessmentFormat.requiredByCourseOutcome && !tlaFormat.requiredByCourseOutcome && courseOutcome.questions.length">


            <div class="ui message">
              No additional information about this course outcome is required.
            </div>

          </div>
        </div>

      </ng-template>



      <div class="button-area">

        <div class="save-button">
          <span class="status-text" *ngIf="isValueChanged && !saving">
            <i class="exclamation triangle icon"></i>Please save your changes.</span>
          <span class="status-text" *ngIf="saving">
            Saving...</span>
          <span class="status-text" *ngIf="justSaved">
            <i class="check icon"></i>Changes have been saved successfully.
          </span>

          <button class="ui button tiny primary" (click)="submitAnswers()" [ngClass]="{'loading': saving}"
            [disabled]="saving || !isValueChanged">Save</button>
        </div>



      </div>




    </ng-container>

  </ng-template>


</ng-template>